import React from 'react';
import { Button } from './Button';
import { scrollToCompra } from '../utils/scroll';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
export function Hero() {
  return <section className="bg-brand-dark text-white pt-3 pb-2 px-3 relative overflow-hidden" data-id="element-79">
      <div className="max-w-3xl mx-auto relative z-10 flex flex-col items-center text-center" data-id="element-80">
        <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold mb-2 leading-tight text-white tracking-tight uppercase" data-id="element-81">
          Organizá tus clases de{' '}
          <span className="text-brand-accent" data-id="element-82">Programación</span> sin empezar
          desde cero cada semana.
        </h1>

        <div className="w-full max-w-[280px] md:max-w-md mx-auto my-1 cursor-pointer transform hover:scale-[1.02] transition-transform duration-200 relative" onClick={scrollToCompra} data-id="element-83">
          <img src="https://cdn.magicpatterns.com/uploads/73CA9gNm8aBScMbBXUf4hq/mockupps_programacion_tecnica.png" alt="Kit Completo Programación Técnica Lista" className="w-full h-auto drop-shadow-xl relative z-10" data-id="element-84" />
        </div>

        <p className="text-sm md:text-base mb-2 font-medium text-gray-300 max-w-2xl mx-auto leading-snug" data-id="element-85">
          Planificá todo tu año de clases de Programación, Informática y
          Tecnología en una tarde — sin leer documentación técnica ni perder
          fines de semana buscando ejemplos que tus alumnos no entienden.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-1.5 md:gap-2 mb-2 w-full text-[10px] md:text-xs font-medium text-gray-300 uppercase tracking-tight" data-id="element-86">
          <span className="bg-brand-card px-2.5 py-1 rounded-full border border-white/10" data-id="element-87">
            📄 100% PDF
          </span>
          <span className="bg-brand-card px-2.5 py-1 rounded-full border border-white/10" data-id="element-88">
            ⚡ Acceso inmediato
          </span>
          <span className="bg-brand-card px-2.5 py-1 rounded-full border border-white/10" data-id="element-89">
            🌍 Toda Latinoamérica
          </span>
        </div>

        <div className="w-full max-w-md mx-auto mb-2" data-id="element-90">
          <Button className="text-sm md:text-lg py-3 shadow-[0_0_20px_rgba(0,255,136,0.3)]" data-id="element-91">
            💻 → QUIERO MI KIT DE PROGRAMACIÓN AHORA
          </Button>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4 text-[9px] md:text-[10px] text-gray-500 font-medium uppercase tracking-tight" data-id="element-92">
          <div className="flex items-center" data-id="element-93">
            <ShieldCheck className="w-3 h-3 mr-1 text-gray-400" data-id="element-94" /> Garantía 7
            días
          </div>
          <div className="flex items-center" data-id="element-95">
            <Lock className="w-3 h-3 mr-1 text-gray-400" data-id="element-96" /> Pago seguro
          </div>
          <div className="flex items-center" data-id="element-97">
            <CreditCard className="w-3 h-3 mr-1 text-gray-400" data-id="element-98" /> Moneda local
          </div>
        </div>
      </div>
    </section>;
}